import { analysisComponetUvLog } from "@/utils/logAnalytics";
import { useEffect, useRef } from "react";

const useCommListener = (componentName: string, visible?: boolean) => {
  // 监测单组件文档页面停留时间，进行埋点
  const startTime = useRef<Date | null>();
  const readTime = useRef<number>(0);

  const getEndTime = () => {
    if (!startTime.current) {
      return;
    }
    const endTime = new Date();
    readTime.current = Math.round(
      Math.abs((startTime.current as Date).getTime() - endTime.getTime()) / 1000
    );
    if (readTime.current === 0) {
      return;
    }
    const trackInfo = {
      componentName,
      leaveTime: `${readTime.current}s`
    };
    startTime.current = null;
    console.log(`销毁:--${componentName}`, trackInfo);
    analysisComponetUvLog({
      cn: componentName,
      at: "leave",
      duration: readTime.current
    });
  };

  useEffect(() => {
    if (typeof visible === "boolean") {
      if (visible) {
        console.log(`进入--${componentName}`);
        analysisComponetUvLog({
          cn: componentName,
          at: "enter"
        });
        startTime.current = new Date(); // 保存打开组件的时间戳
      }
    } else {
      startTime.current = new Date(); // 保存进入组件的时间戳
    }
    // 计算停留时间
    return () => {
      getEndTime();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
};

export default useCommListener;
